export default __webpack_public_path__ + "static/media/chausath-yogini-temple.5b05ff15.jpg";